import { useCallback, useMemo } from 'react';

import { getToolDefaultAssetType } from 'src/data/generationTool';
import * as events from 'src/lib/events';
import * as gtm from 'src/lib/gtm';
import { useTrackGtmEvent } from 'src/services';
import { PAGES, useTrackingEvent } from 'src/services/useTrackingEvent';
import { useUiActions } from 'src/store';

import { useMainActions } from '../store';

export const useCommonPageEvents = () => {
  const uiActions = useUiActions();
  const trackingEvent = useTrackingEvent();
  const mainActions = useMainActions();
  const trackGtmEvent = useTrackGtmEvent();

  const trackOpenVariationDetailsClick = useCallback(
    (variation) => {
      const project = mainActions.getProject();
      const tab = uiActions.getTextDetailsPanelTab();

      const attributes = {
        projectId: String(project.id),
        assetType: getToolDefaultAssetType(variation.generationTool),
        variationId: variation.id,
        page: PAGES.editor,
        generationTool: variation.generationTool,
        tab,
      };

      trackingEvent(events.PROJECT.clickedVariationDetails, attributes);
      trackGtmEvent(gtm.EVENTS.clickedVariationDetails, attributes);
    },
    [trackingEvent, mainActions, trackGtmEvent, uiActions]
  );

  const trackVariationDetailsTemplateClick = useCallback(
    (annotationType, annotationContent, eventProps) => {
      const project = mainActions.getProject();

      trackingEvent(events.PROJECT.clickedVariationAddTemplateOnDetails, {
        projectId: String(project.id),
        annotationType,
        content: annotationContent,
        ...eventProps,
      });
    },
    [trackingEvent, mainActions]
  );

  const trackRecomposeDetailsTemplateClick = useCallback(
    (annotationType, annotationContent) => {
      const project = mainActions.getProject();

      trackingEvent(events.PROJECT.clickedRecomposeAddTemplateOnDetails, {
        projectId: String(project.id),
        annotationType,
        content: annotationContent,
      });
    },
    [trackingEvent, mainActions]
  );

  return useMemo(
    () => ({
      trackOpenVariationDetailsClick,
      trackVariationDetailsTemplateClick,
      trackRecomposeDetailsTemplateClick,
    }),
    [
      trackOpenVariationDetailsClick,
      trackVariationDetailsTemplateClick,
      trackRecomposeDetailsTemplateClick,
    ]
  );
};
